import {useEffect, useRef} from 'react';

import {useSelector} from 'react-redux';

import {getUserProperties} from 'static/three-oh/src/modules/selectors/userSelectors';

import {setEssentialOnlyConsent} from './dgBannerApi';

const useStudentConsentSuppression = () => {
  const {isStudent} = useSelector(getUserProperties);
  const hasSuppressedRef = useRef(false);

  useEffect(() => {
    if (hasSuppressedRef.current || !isStudent) {
      return;
    }

    const suppressed = setEssentialOnlyConsent();
    if (suppressed) {
      hasSuppressedRef.current = true;
    }
  }, [isStudent]);
};

export default useStudentConsentSuppression;
